import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../../app.interface';
import * as fromAlert from './alert';
import { AlertTypeEnum } from '../alert/alert-type.enum';

export * as fromShared from './alert';
export interface AlertState {
  alertType: fromAlert.State;
  message: fromAlert.State;
}

export interface State extends AppState {
  shared: fromAlert.State;
}

export const reducers = {
  shared: fromAlert.reducer,
};

export const alertState = createFeatureSelector<AlertState>('shared');
export const selectShared = createFeatureSelector<fromAlert.State>('shared');

// export const alertEntityState = createSelector(
//   alertState,
//   state => state.alert
// );

export const selectAlertType = createSelector(
  alertState,
  (state: AlertState) => state.alertType
);

export const getAlertType = createSelector(
  selectShared,
  fromAlert.getAlertType
);

export const selectMessage = createSelector(
  alertState,
  (state: AlertState) => state.message
);

export const getMessage = createSelector(
  selectShared,
  fromAlert.getMessage
);

